import { Injectable } from "@angular/core";
import { DefaultService } from "src/app/core/services/default.service";
import {
  IDistrict,
  IDistrictData,
  IDistrictInsert,
  IDistrictUpdate,
} from "../models/districts.interface";
import { ColDef } from "ag-grid-community";
import { ResidentActionsComponent } from "src/app/shared/datatable/actions/resident-actions.component";
import { EditDistrictFormComponent } from "../pages/districts/edit-district-form/edit-district-form.component";
import { E_ACTIONS, E_SUBJECT } from "../../../core/enums/Permission.enum";

@Injectable({
  providedIn: "root",
})
export class DistrictService extends DefaultService<
  IDistrictData,
  IDistrictInsert,
  IDistrictUpdate
> {
  getServiceKey(): string {
    return "DistrictService";
  }

  override columnDefs: ColDef[] = [
    {
      headerName: "GEOGRAPHY.DISTRICTS.TABLE_HEADERS.ID",
      field: "id",
      maxWidth: 150,
    },
    {
      headerName: "GEOGRAPHY.DISTRICTS.TABLE_HEADERS.NAME",
      field: "name",
    },
    {
      headerName: "GEOGRAPHY.DISTRICTS.TABLE_HEADERS.REGION",
      field: "regionName",
      filter: false,
      sortable: false,
    },
    {
      headerName: "GEOGRAPHY.MODAL_BUTTON.SOATO",
      field: "soatos",
      valueFormatter: (params) => {
        return params.value ? params.value.join(", ") : "";
      },
      minWidth: 200,
    },
    {
      headerName: "GEOGRAPHY.REGIONS.TABLE_HEADERS.CADASTRAL_CODE",
      field: "cadastralCode",
      valueFormatter: (params) => {
        const value = params.value;
        return value ? value.replace(/(\d{2})(?=\d)/g, "$1:") : value;
      },
    },
    {
      headerName: "STATISTICS.RESIDENT_COUNT",
      field: "statisticalInhabitantCount",
      isMoney: true,
    },
    {
      headerName: "STATISTICS.MAHALLAS_COUNT",
      field: "statisticalMahallaCount",
      isMoney: true,
    },
    {
      field: "actions",
      headerName: "TOOLS.RESIDENTS.TABLE_HEADERS.ACTION",
      cellRenderer: ResidentActionsComponent<IDistrict>,
      cellRendererParams: {
        handleDelete: this._ability.can(E_ACTIONS.DELETE, E_SUBJECT.DISTRICTS)
          ? this.onDelete.bind(this)
          : null,
        handleEdit: this._ability.can(E_ACTIONS.UPDATE, E_SUBJECT.DISTRICTS)
          ? this.onEdit.bind(this)
          : null,
      },
      suppressNavigable: true,
      cellClass: "no-border",
      pinned: "right",
    },
  ];

  constructor() {
    super(`user-service/districts`);
  }

  onDelete(data: IDistrict) {
    this.selectedRow.set(data);
    this._confirmationDialogService
      .open({
        title: "GEOGRAPHY.DISTRICTS.MODAL.TITLE_DELETE",
        message: "GEOGRAPHY.DISTRICTS.MODAL.DELETE_MODAL_SUBTITLE",
      })
      .then((res) => {
        if (res) {
          this.subscriptions = this.delete(data.id).subscribe(() => {
            this._toastService.success("TOAST.TOAST_DELETE");
            this.subscriptions.unsubscribe();
          });
        }
      });
  }

  onEdit(data: IDistrict) {
    this.selectedRow.set(data);
    this._modalService.open({
      component: EditDistrictFormComponent,
      title: "GEOGRAPHY.DISTRICTS.MODAL.TITLE_UPDATE",
      componentOptions: { item: data },
    });
  }
}
